/*
 * Module for the Seminar Create Estimates job criteria page
 */
rs.module("content/jobs/criteria/seminarcreateestimates",

    [],

    function () {

        // Initialize the page
        function initialize(jsSelectors) {

            var criteria = $.js(jsSelectors.criteria);

            var availableOnMDCheckbox = criteria.js(jsSelectors.availableOnMDCheckbox);
            var notifyViaEmailFlag = criteria.js(jsSelectors.notifyViaEmailFlag);

            // disable the notify via email checkbox
            availableOnMDCheckbox.change(function () {
                if (!availableOnMDCheckbox.is(":checked")) {
                    notifyViaEmailFlag.setChecked(false);
                }
                notifyViaEmailFlag.setDisabled(!availableOnMDCheckbox.is(":checked"));
            });
        }
    
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);